/**
 * @generated SignedSource<<4897a2fde10f0a2105d538cb79ee616a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileSectionLiveBids_viewer$data = {
  readonly bidderLiveBids: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly auction: {
          readonly item: {
            readonly metadata: {
              readonly name?: string | null;
            } | null;
            readonly serviceId: string | null;
            readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_nftItem">;
          } | null;
          readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_nftAuction">;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_nftAuctionBidderRef">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftHeartPillProvider_viewer" | "NftItemTile_viewer">;
  readonly " $fragmentType": "NftProfileSectionLiveBids_viewer";
};
export type NftProfileSectionLiveBids_viewer$key = {
  readonly " $data"?: NftProfileSectionLiveBids_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileSectionLiveBids_viewer">;
};

import NftProfileSectionLiveBidsPaginationQuery_graphql from './NftProfileSectionLiveBidsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "bidderLiveBids"
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "liveBidsCursor"
    },
    {
      "kind": "RootArgument",
      "name": "liveBidsFirst"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "username"
    },
    {
      "kind": "RootArgument",
      "name": "walletAddress"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "liveBidsFirst",
        "cursor": "liveBidsCursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "liveBidsFirst",
          "cursor": "liveBidsCursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": NftProfileSectionLiveBidsPaginationQuery_graphql
    }
  },
  "name": "NftProfileSectionLiveBids_viewer",
  "selections": [
    {
      "alias": "bidderLiveBids",
      "args": [
        {
          "kind": "Variable",
          "name": "bidderAddress",
          "variableName": "walletAddress"
        },
        {
          "kind": "Literal",
          "name": "status",
          "value": "BIDDER_LIVE"
        },
        {
          "kind": "Variable",
          "name": "username",
          "variableName": "username"
        }
      ],
      "concreteType": "NftAuctionsByBidderConnection",
      "kind": "LinkedField",
      "name": "__NftProfileSectionLiveBids_bidderLiveBids_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NftAuctionsByBidderEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NftAuctionBidderRef",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NftItemTile_nftAuctionBidderRef"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NftAuction",
                  "kind": "LinkedField",
                  "name": "auction",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "NftItemTile_nftAuction"
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NftItem",
                      "kind": "LinkedField",
                      "name": "item",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "serviceId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "metadata",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "name",
                                  "storageKey": null
                                }
                              ],
                              "type": "NftDigitalArtMetadata",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "NftItemTile_nftItem"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftHeartPillProvider_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTile_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "f2cd09c67215d0222921afb4c9be1711";

export default node;
